<img
  nz-dropdown
  nzTrigger="click"
  [nzDropdownMenu]="menu"
  [src]="languageFlag()"
  [alt]="selectedLanguage"
  [width]="iconSize()"
/>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu nzSelectable>
    @for (language of languages; track $index) {
      <li
        nz-menu-item
        [attr.aria-hidden]="true"
        (click)="onChangeLanguage(language.code)"
      >
        <a>
          <img
            width="18"
            [src]="assetsFolder + language.code + '.svg'"
            [alt]="language.name | translate"
          />
          {{ language.name | translate }}
        </a>
      </li>
    }
  </ul>
</nz-dropdown-menu>
